import { useEffect, useState } from 'react';
import axios from '../utils/axiosInstance';

/**
 * Fetches /api/transly/locales/ and returns the list of NON-primary locale
 * codes that the backend currently allows translating to (TRANSLY_LOCALE_ALLOWLIST).
 *
 * Replaces hardcoded ['de','es'] lists in table pages — when the operator
 * widens the allowlist (e.g. adds 'pl'), every locale-aware table picks up
 * the new column on next page load without a frontend change.
 *
 * Returns { locales, loading, error } where `locales` is e.g. ['de','es','pl'].
 */
export default function useTargetLocales() {
  const [locales, setLocales] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    axios
      .get('api/transly/locales/')
      .then((res) => {
        if (cancelled) return;
        const codes = (res.data || [])
          .filter((l) => !l.primary)
          .map((l) => l.locale);
        setLocales(codes);
      })
      .catch((err) => {
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { locales, loading, error };
}
